import FormData from "form-data";

import BaseService from "./base";

const OPTIONAL_UPLOAD_FIELDS = [
  { field: "file", apiFieldName: "file" },
  { field: "folderId", apiFieldName: "folder_id" },
  { field: "s3Url", apiFieldName: "s3_url" },
  { field: "mimeType", apiFieldName: "mime_type" },
];

class UserContentService {
  load() {
    return BaseService.get("/api/user-contents");
  }

  edit(contentId, duration, name, tag) {
    const data = {
      duration,
      name,
      tag,
    };

    return BaseService.put(`/api/user-content/${contentId}`, data);
  }

  archive(contentIds) {
    return BaseService.put("/api/user-contents/archive", { contentIds });
  }

  upload(uploadData) {
    const { name, duration } = uploadData;


    const data = new FormData();
    data.append("name", name);
    data.append("duration", duration);

    OPTIONAL_UPLOAD_FIELDS.forEach((f) => {
      const { field, apiFieldName } = f;
      const val = uploadData[field];
      if (val) {
        data.append(apiFieldName, val);
      }
    });
    return BaseService.post("/api/user-content", data, "form");
  }
}

const userContentService = new UserContentService();
export default userContentService;
export { userContentService };
